var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "top-c" }, [
        _vm._v("个人中心装修-" + _vm._s(_vm.pageName)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "left-box" }, [
          _c("div", { staticClass: "have-bg", style: {} }, [
            _c(
              "div",
              { staticClass: "left-son" },
              [
                _c(
                  "div",
                  {
                    style: {
                      "background-image":
                        "url(" + _vm.personalPageConfig.backGroundPic + ")",
                      padding: "10px 6px",
                    },
                  },
                  [
                    _c("div", { staticClass: "top-nav" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            flex: "1",
                            "margin-left": "5px",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              style: {
                                color: _vm.personalPageConfig.textColor,
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "font-size": "11px" } },
                                [_vm._v("Hi,小明")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    color: "#fff",
                                    margin: "5px 0",
                                    background:
                                      "linear-gradient( 180deg, #755A43 0%, #32261C 100%)",
                                    padding: "2px 5px",
                                    "font-size": "11px",
                                    "border-radius": "3px",
                                    width: "60px",
                                    "text-align": "center",
                                  },
                                },
                                [_vm._v("皇冠会员")]
                              ),
                              _vm._v(" "),
                              _vm._m(1),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-around",
                                flex: "1",
                                position: "relative",
                              },
                            },
                            [
                              _vm.personalPageConfig.contactUsEntry === 1
                                ? _c("img", {
                                    staticStyle: {
                                      width: "30px",
                                      height: "35px",
                                      display: "block",
                                    },
                                    attrs: {
                                      src: _vm.personalPageConfig.customerPic
                                        ? _vm.personalPageConfig.customerPic
                                        : require("@/assets/kf.png"),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.personalPageConfig.referrerEntry === 1
                                ? _c("img", {
                                    staticStyle: {
                                      width: "30px",
                                      height: "35px",
                                      display: "block",
                                    },
                                    attrs: {
                                      src: _vm.personalPageConfig.referrerPic
                                        ? _vm.personalPageConfig.referrerPic
                                        : require("@/assets/tjr.png"),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.personalPageConfig.messageEntry === 1
                                ? _c("img", {
                                    staticStyle: {
                                      width: "30px",
                                      height: "35px",
                                      display: "block",
                                    },
                                    attrs: {
                                      src: _vm.personalPageConfig.messagePic
                                        ? _vm.personalPageConfig.messagePic
                                        : require("@/assets/xx.png"),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.personalPageConfig.contactUsEntry === 1
                                ? _c("img", {
                                    staticStyle: {
                                      width: "30px",
                                      height: "35px",
                                      display: "block",
                                    },
                                    attrs: {
                                      src: _vm.personalPageConfig.settingPic
                                        ? _vm.personalPageConfig.settingPic
                                        : require("@/assets/sz.png"),
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.personalPageConfig.wxRemind === 1
                                ? _c("img", {
                                    staticStyle: {
                                      width: "88px",
                                      height: "25px",
                                      display: "block",
                                      position: "absolute",
                                      right: "0",
                                      top: "35px",
                                    },
                                    attrs: {
                                      src: require("@/assets/wx_icon.png"),
                                    },
                                  })
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.dataDisplay, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "my-over-div",
                          style: {
                            paddingLeft:
                              item.horizontalMargin === 1 ? "6px" : 0,
                            paddingRight:
                              item.horizontalMargin === 1 ? "6px" : 0,
                            marginTop: item.topMargin === 1 ? "6px" : 0,
                          },
                          on: {
                            mouseover: function ($event) {
                              return _vm.bothMouseOver(item, index)
                            },
                          },
                        },
                        [
                          item.boole
                            ? _c(
                                "div",
                                {
                                  staticClass: "move-box",
                                  on: {
                                    mouseleave: function ($event) {
                                      return _vm.bothMouseLeave(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          type: "primary",
                                          icon: "el-icon-edit",
                                          size: "mini",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.bothClick(item)
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-top": "10px",
                                            position: "absolute",
                                            top: "0",
                                            left: "0",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "模块ID:" + _vm._s(item.moduleId)
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          item.status === 1
                            ? _c(item.componentCode, {
                                key: item.timestamp,
                                tag: "component",
                                attrs: { "item-detail": item },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm._l(_vm.tableData, function (item, index) {
                  return _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.componentCode !== "dataDisplay",
                          expression: "item.componentCode!=='dataDisplay'",
                        },
                      ],
                      key: index,
                      staticClass: "my-over-div",
                      style: {
                        paddingLeft: item.horizontalMargin === 1 ? "6px" : 0,
                        paddingRight: item.horizontalMargin === 1 ? "6px" : 0,
                        marginTop: item.topMargin === 1 ? "6px" : 0,
                      },
                      on: {
                        mouseover: function ($event) {
                          return _vm.bothMouseOver(item, index)
                        },
                      },
                    },
                    [
                      item.boole
                        ? _c(
                            "div",
                            {
                              staticClass: "move-box",
                              on: {
                                mouseleave: function ($event) {
                                  return _vm.bothMouseLeave(item)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      type: "primary",
                                      icon: "el-icon-edit",
                                      size: "mini",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.bothClick(item)
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "margin-top": "10px",
                                        position: "absolute",
                                        top: "0",
                                        left: "0",
                                      },
                                    },
                                    [_vm._v("模块ID:" + _vm._s(item.moduleId))]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.status === 1
                        ? _c(item.componentCode, {
                            key: item.timestamp,
                            tag: "component",
                            attrs: { "item-detail": item },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
              ],
              2
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right-box" }, [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center",
                "margin-bottom": "20px",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    "align-items": "center",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "18px",
                        "font-weight": "bold",
                        color: "#282828",
                        "margin-right": "10px",
                      },
                    },
                    [_vm._v("\n            模块编辑\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.addModule()
                        },
                      },
                    },
                    [_vm._v("新增模块+")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.goBack()
                        },
                      },
                    },
                    [_vm._v("返回上一页")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    "align-items": "center",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "success" },
                      on: { click: _vm.topConfig },
                    },
                    [
                      _vm._v("编辑顶部信息"),
                      _c("i", { staticClass: "el-icon-right" }),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "my_table_name" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    "element-loading-text": "拼命加载中",
                    "element-loading-spinner": "el-icon-loading",
                    "element-loading-background": "rgba(0, 0, 0, 0.8)",
                    "row-key": "id",
                    "header-cell-style": { "text-align": "center" },
                    "cell-style": { "text-align": "center" },
                    data: _vm.tableData,
                    border: "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "模块ID", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.moduleId))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "模块名称", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_c("span", [_vm._v(_vm._s(scope.row.name))])]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "备注信息", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.remark))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "上边距", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-switch", {
                              attrs: { "active-value": 1, "inactive-value": 0 },
                              on: {
                                change: function ($event) {
                                  return _vm.allChange(scope.row, "topMargin")
                                },
                              },
                              model: {
                                value: scope.row.topMargin,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "topMargin", $$v)
                                },
                                expression: "scope.row.topMargin",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "左右边距", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-switch", {
                              attrs: { "active-value": 1, "inactive-value": 0 },
                              on: {
                                change: function ($event) {
                                  return _vm.allChange(
                                    scope.row,
                                    "horizontalMargin"
                                  )
                                },
                              },
                              model: {
                                value: scope.row.horizontalMargin,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "horizontalMargin", $$v)
                                },
                                expression: "scope.row.horizontalMargin",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "展示状态", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-switch", {
                              attrs: { "active-value": 1, "inactive-value": 0 },
                              on: {
                                change: function ($event) {
                                  return _vm.allChange(scope.row, "status")
                                },
                              },
                              model: {
                                value: scope.row.status,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "status", $$v)
                                },
                                expression: "scope.row.status",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              scope.row.componentCode === "dataDisplay"
                                ? _c("img", {
                                    staticClass: "icon_box",
                                    attrs: {
                                      src: require("@/assets/r_notMove.png"),
                                      alt: "",
                                    },
                                  })
                                : _c("img", {
                                    staticClass: "icon_box dg_div",
                                    attrs: {
                                      src: require("@/assets/r_move.png"),
                                      alt: "",
                                    },
                                  }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "icon_box",
                                staticStyle: { margin: "0 10px" },
                                attrs: {
                                  src: require("@/assets/r_detail.png"),
                                  alt: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.moduleUpdate(scope.row)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "icon_box",
                                attrs: {
                                  src: require("@/assets/r_del.png"),
                                  alt: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.del(scope.row)
                                  },
                                },
                              }),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("addModule", {
        ref: "addModule",
        attrs: { "page-id": _vm.pageId, "module-type": 2 },
        on: { refresh: _vm.findModule },
      }),
      _vm._v(" "),
      _c("topModelPop", {
        ref: "topModelPop",
        attrs: { "page-id": _vm.pageId },
        on: { refresh: _vm.findModule },
      }),
      _vm._v(" "),
      _c("dataDisplayPop", {
        ref: "dataDisplayPop",
        attrs: { "page-id": _vm.pageId },
        on: { refresh: _vm.findModule },
      }),
      _vm._v(" "),
      _c("bannerListPop", {
        ref: "bannerListPop",
        on: { refresh: _vm.refreshModule },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticStyle: { width: "60px", height: "60px", display: "block" },
        attrs: { src: require("@/assets/user_icon.png") },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "font-size": "11px" } }, [
      _vm._v("邀请码 xxx"),
      _c("span", { staticStyle: { "margin-left": "8px" } }, [_vm._v("复制")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }